import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import RechargeView from './components/recharge.vue';

var ReChargePage = function (_super) {
  __extends(ReChargePage, _super);

  function ReChargePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.serviceBodyAccountLoading = true;
    _this.columns = [];
    _this.accountFormData = {};
    _this.visible = false;
    _this.serviceBodyAccountList = [];
    return _this;
  }

  ReChargePage.prototype.queryServiceBodyAccountList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            this.serviceBodyAccountLoading = true;
            return [4, this.$api.finance.queryServiceBodyAccountList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.serviceBodyAccountLoading = false;
            this.serviceBodyAccountList = data;
            return [2];
        }
      });
    });
  };

  ReChargePage.prototype.handleAccountList = function () {
    this.visible = true;
  };

  ReChargePage.prototype.handleClose = function () {
    this.visible = false;
  };

  ReChargePage.prototype.setDefault = function () {
    var accountCodeNum = this.$route.query.account_code;
    var rechargeCurrencyStr = this.$route.query.recharge_currency;

    if (accountCodeNum && rechargeCurrencyStr) {
      this.accountFormData = {
        accountCode: accountCodeNum,
        rechargeCurrency: rechargeCurrencyStr
      };
    }
  };

  ReChargePage.prototype.handleSubmit = function () {
    var rechargeRef = this.$refs.rechargeRef;
    rechargeRef.submit(function () {});
  };

  ReChargePage.prototype.created = function () {
    this.columns = [{
      title: this.t('银行名'),
      dataIndex: 'bank_name',
      filterEmpty: true
    }, {
      title: this.t('开户行'),
      dataIndex: 'bank_branch',
      filterEmpty: true
    }, {
      title: this.t('币别'),
      dataIndex: 'currency_Code',
      filterEmpty: true
    }, {
      title: this.t('账号'),
      dataIndex: 'account_number',
      filterEmpty: true
    }];
    this.queryServiceBodyAccountList();
    this.setDefault();
  };

  ReChargePage = __decorate([Component({
    components: {
      RechargeView: RechargeView
    }
  })], ReChargePage);
  return ReChargePage;
}(Vue);

export default ReChargePage;